import React, {useEffect, useState} from 'react'

export const UserContext = React.createContext(undefined);
export const UserDispatchContext = React.createContext(undefined);

export const UserProvider = ({children}) => {
    const [user, setUser] = useState()

    //remove currentUser in localStorage
    useEffect(() => {
        const handleStorage = () => {
            const currentUser = localStorage.getItem("currentUser")
            if (currentUser) return
            setUser(undefined)
        }

        window.addEventListener("storage", handleStorage)

        return () => {
            // When the component unmounts remove the event listener
            window.removeEventListener("storage", handleStorage)
        }
    }, [])

    //get currentUser in localStorage
    useEffect(() => {
        const currentUser = localStorage.getItem("currentUser")
        if (!currentUser) return
        setUser(JSON.parse(currentUser))
    }, [])

    //set currentUser in localStorage
    useEffect(() => {
        if (!user) return
        localStorage.setItem("currentUser", JSON.stringify(user))
    }, [user])

    return (
        <UserContext.Provider value={{user}}>
            <UserDispatchContext.Provider value={{setUser}}>
                {children}
            </UserDispatchContext.Provider>
        </UserContext.Provider>
    )
}